import { CustomForm, CustomFormControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useFormBuilderCreate = () =>
  useMutationWithLoading(
    async (param: { customForm: CustomForm; xTENANTID?: string }) =>
      new CustomFormControllerApi(getConfigObject()).createCustomForm(
        param?.customForm,
        param?.xTENANTID
      )
  );
